import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../api.service';

@Component({
  selector: 'lib-forgot-password-code',
  templateUrl: './forgot-password-code.component.html',
  styleUrls: ['./forgot-password-code.component.scss']
})
export class ForgotPasswordCodeComponent implements OnInit {
  forgotPasswordForm: FormGroup;
  submitted: boolean = false;
  @Output() dataRedirectEvent = new EventEmitter();
  constructor(private formbuilder: FormBuilder,private apiService: ApiService) { }

  ngOnInit() {
    this.forgotPasswordForm = this.formbuilder.group({
      email: ['', Validators.required]
    })
  }
  get f() {
    return this.forgotPasswordForm.controls;
  }
  forgotPasswordSubmit(){
    this.submitted = true;
    if (this.forgotPasswordForm.invalid){
      return;
    }
     var data = this.forgotPasswordForm.value;
     this.apiService.forgotPasswordGen(data).subscribe(res=>{
      if(res){
        this.dataRedirectEvent.emit({event:'success'})
      } else {
        this.dataRedirectEvent.emit({event:'failure'})
      }
     })
  }
} 
